import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import './impact.css';

function Impact() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <motion.div
      ref={ref}
      className="impact-section"
      initial={{ opacity: 0, y: 50 }}
      animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <div className="impact-container">
        <h2 className="impact-title">Customer & Account Impact</h2>

        <div className="impact-points">
          <div className="impact-item">
            <span className="impact-bullet">01</span>
            <p>Grew account ownership from <strong>4 to 19 accounts</strong> while contributing to <strong>200%+ revenue growth</strong>.</p>
          </div>

          <div className="impact-item">
            <span className="impact-bullet">02</span>
            <p>Managed high-value client relationships across onboarding, retention, renewals, expansion conversations, and day-to-day issue resolution.</p>
          </div>

          <div className="impact-item">
            <span className="impact-bullet">03</span>
            <p>Identified account risks and opportunities early, then coordinated internal follow-through to protect relationships and support growth.</p>
          </div>

          <div className="impact-item">
            <span className="impact-bullet">04</span>
            <p>Turned client feedback into clear internal priorities — helping teams understand what mattered, why it mattered, and what action was needed.</p>
          </div>

          <div className="impact-item">
            <span className="impact-bullet">05</span>
            <p>After Spoke, was brought into a new project by the former CEO to rebuild the web platform for All Seasons Landscaping, strengthening the product and technical fluency I now bring to customer-facing roles.</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default Impact;